import React from 'react'
import './not-available.css'

const NotAvailable = ({name = 'Value'}) => {
  return (
    <abbr className="not-available" title={`${name} is not available`}>
      N/A
    </abbr>
  )
}

export default NotAvailable


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/views/not-available/index.jsx